import React from 'react'
import { Dialog, DialogActions, DialogContent, DialogTitle, Tooltip } from '@mui/material'
import { CrossCircledIcon } from '@radix-ui/react-icons'
import { Button } from 'src/Common/ui/button'

function ApproveDialog ({ isOpened, handleCloseModal, handleProceed }) {
    return (
        <>
            <Dialog
                open={isOpened}
                sx={{ minHeight: '300px' }}
                PaperProps={{
                    style: { minHeight: '180px', minWidth: '350px' }
                }}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle sx={{ padding: '0px 10px 0px 10px', display: 'flex', alignItems: 'center', backgroundColor: 'hsl(var(--primary))', flexDirection: 'row', height: '40px', justifyContent: 'space-between' }}>
                    <div style={{ fontSize: '20px', fontWeight: 'bold', color: 'hsl(var(--card))' }}>Information</div>
                    <Tooltip title="Close" placement="top" componentsProps={{ tooltip: { sx: { bgcolor: 'hsl(var(--card))', border: '1px solid hsl(var(--muted))', color: 'black', boxShadow: '0px 4px 4px 0px hsl(var(--shadow))' } } }}>
                        <CrossCircledIcon onClick={() => handleCloseModal()} style={{ height: '30px', width: '30px', fontWeight: 'bold', color: 'hsl(var(--card))', cursor: 'pointer' }} />
                    </Tooltip>
                </DialogTitle>
                <DialogContent sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', padding: '0px 24px 0px 24px', borderBottom: '2px solid hsl(var(--border))' }}>
                Responsible and Accountable users are same in the RACI, This compliance is auto-approved
                </DialogContent>
                <DialogActions sx={{ width: '100%', display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }}>
                    <Button onClick={() => handleProceed('approve')} autoFocus>
                            Yes, Proceed
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ApproveDialog
